import { CSSProperties, ReactNode, useContext } from "react"
import { MainContext } from "../../controllers/main"
import { Grow, Paper } from "@mui/material"

const LeaderboardListContainer = ({
  children,
  style,
}: {
  children: ReactNode
  style?: CSSProperties
}) => {
  const { animation, showPadding } = useContext(MainContext)

  return (
    <Grow in={animation} timeout={350}>
      <Paper
        sx={{
          width: showPadding === "yes" ? "calc(100% - 32px)" : "100%",
          overflow: "hidden",
          margin: showPadding === "yes" ? "16px" : 0,
          marginTop: 0,
        }}
        style={{ ...style }}
      >
        {children}
      </Paper>
    </Grow>
  )
}

export default LeaderboardListContainer
